import React from 'react'

import { urlCopyToClipboard } from "../../assets/Js/urlCopyToClipboard";
import DisplayPicture from "../DisplayPicture/DisplayPicture";
import { useHistory } from "react-router-dom";
import Stars from "../Stars/Stars";
export default function NewMarketplaceCard({
  id,
  name,
  image,
  tagline,
  address,
}) {
  const history = useHistory();
  const _link = `/marketplace/${id}`;
  const redirectToTrack = () => {
    history.push(_link);
  };
  const copyToClipboard = () => {
    let url = window.location;
    urlCopyToClipboard(url.host + _link);
  };

  return (
    <div className="listing row no-gutters">
      <DisplayPicture image={image} className="img col-lg-4" showGymAvatar={true}/>
      <div className="info col-lg-8">
        <h3 className="font-weight-bold">
          {name}
        </h3>
        <div className="subinfo">
          <div className="stars-info mr-2">
            <Stars/>
          </div>
        </div>
        <div className="subinfo">
          {address}
        </div>
        <hr />
        <div className="d-flex pricing-info">
          <span>
            Get shareable link
            <i
              onClick={copyToClipboard}
              className="mdi mdi-link-variant pointerCursor shareableLink"
            ></i>
          </span>
          <button
            type="submit"
            class="secondaryBtn brand-btn"
            onClick={redirectToTrack}
          >
            VIEW TRACKS
          </button>
        </div>
      </div>
    </div>
  );
}

